module.exports = __webpack_public_path__ + "static/media/matrix1.f61ca650.gif";